module.exports = __webpack_public_path__ + "static/media/tree_1.34cc041c.JPG";